/* eslint-disable @typescript-eslint/no-empty-function */
import { createContext } from 'react'

import { Analytics } from './analytics'

export const defaultAnalytics: Analytics = {
  enableSegment: () => {},
  trackCheckoutStarted: () => {},
  trackDiscountCodeApplied: () => {},
  trackEvent: () => {},
  trackGoal: () => {},
  trackIdentify: () => {},
  trackOrderCompleted: () => {},
  trackOrderConfirmationsChanged: () => {},
  trackOrderDetailsFilled: () => {},
  trackOrderPaymentMethodSelected: () => {},
  trackOrderPaymentStarted: () => {},
  trackOrderWalletPaymentStarted: () => {},
  trackPage: () => {},
  trackTagManagerEvent: () => {},
  user: () => ({}),
}

const AnalyticsContext = createContext(defaultAnalytics)

export default AnalyticsContext
